import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Grid,
    Slide,
    Typography,
    FormControl,
    Button
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment'
import WrappedAutocomplete from 'common/components/custom/WrappedAutocomplete'
import WrappedKeyboardDatePicker from 'common/components/custom/WrappedKeyboardDatePicker';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[400],
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

class AssetHistoryLocationEditDialog extends Component {


    render() {
        const { assetLocationEditDialog, selectedLocationStartDateEdit, locations, selectedLocationEdit } = this.props

        return (
            <Dialog onClose={this.props.closeLocationHistoryDialog} open={assetLocationEditDialog} TransitionComponent={Transition} fullWidth maxWidth="sm">
                <DialogTitle className="dialog-header-custom">{this.props.t("edit_asset_location_history")}</DialogTitle>
                <form onSubmit={this.props.updateLocationHistory} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedKeyboardDatePicker
                                            name="selectedLocationStartDateEdit"
                                            label={this.props.t("starting_date_of_usage")}
                                            value={selectedLocationStartDateEdit ? moment(selectedLocationStartDateEdit, "DD-MM-YYYY") : null}
                                            onChange={this.props.handleChangeLocationEditStartDate}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <FormControl variant="outlined" fullWidth>
                                            <WrappedAutocomplete
                                                label={"location"}
                                                placeholder={this.props.t("location")}
                                                name="location"
                                                value={selectedLocationEdit}
                                                options={locations}
                                                onChange={this.props.handleChangeLocationEdit}
                                                getOptionLabel={option => option.address ? option.address + ", " + this.props.t("floor") + " : " + option.floor + ", " + this.props.t("room") + " : " + option.room : ""}
                                                getOptionSelected={(option, value) => option.id === value.id}
                                                renderOption={option => (
                                                    <React.Fragment>
                                                        {option.address ? option.address + ", " + this.props.t("floor") + " : " + option.floor + ", " + this.props.t("room") + " : " + option.room : ""}
                                                    </React.Fragment>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.props.closeLocationHistoryDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" /* disabled={this.props.disabledLocationEditButton} */>
                            {this.props.t("update")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog >
        );
    }
}

export default withRouter(withTranslation()(AssetHistoryLocationEditDialog));